<template>
  <div class="servicebox">
    <section id="banner">
      <div
        class="wrapper"
        :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"
      ></div>
    </section>
    <section id="breadcrumb">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;公司简介&nbsp;
      </div>
    </section>
    <section id="content">
      <div class="wrapper" v-html="content.content">
        
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCategoryInfo, getContentList } from "@/api/content";
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
      categoryId: this.$route.query.categoryId,
      categoryInfo: {},
      content: {},
    };
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then((res) => {
        if (res.code !== 200) return;
        this.categoryInfo = res.data;
        this.categoryInfo.categoryPic =
          process.env.BASE_API + "/web" + this.categoryInfo.categoryPic;
      });
    },
    getContent() {
      let params = {
        size: 1,
        current: 1,
        categoryId: this.categoryId,
      };
      getContentList(params).then((res) => {
        if (res.code !== 200) return;
        if (res.data.records && res.data.records.length > 0) {
          this.content = res.data.records[0];
        }
      });
    },
  },
  mounted() {
    this.getBanner();
    this.getContent();
  },
};
</script>

<style scoped >
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url(../assets/20170519-17072284.jpg) center top no-repeat;
  background-size: 100% auto;
}
#banner .wrapper {
  background-size: auto 100% !important;
}
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 140px;
  }
}
@media screen and (max-width: 1300px) {
  section .wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  #banner .wrapper {
    background-size: auto 100%;
  }
}

section#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
  section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1000px) {
  section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
  }
}
#content .wrapper {
  width: 960px;
  padding: 40px 0;
  text-align: left;
  box-sizing: border-box;
}
@media screen and (max-width: 1300px) {
  .servicebox section .wrapper {
    width: 100%;
  }
}

#content .wrapper .title {
  font-size: 24px;
  color: #146cbd;
  padding: 20px 0;
  border-bottom: 1px #ccc solid;
  margin-bottom: 40px;
  font-family: latoweb;
}
#content .wrapper .des {
  line-height: 32px;
  font-size: 18px;
  padding: 0 0 40px;
  font-family: latoweblight;
  color: #666;
}
#content .wrapper .des a {
  font-size: 18px;
  line-height: 26px;
  padding: 0;
  font-family: latowebbold;
  text-decoration: underline;
  color: #15262e;
}
#content .wrapper .des .subtitle {
  font-size: 20px;
  font-family: latoweb;
  margin-top: 40px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cculture.vue